// extracted by mini-css-extract-plugin
export default {"chart":"ParetoChart_chart__4-NXE","topCausesPercentagText":"ParetoChart_topCausesPercentagText__broSa"};